import React from 'react';
import Notification from '~/containers/Views/Notification/Notification.ui';

function FormIsPostPagoComponent({ handleChangeToken, handleSubmitToken, error, btnText, tokenReenviar, resend }) {
  return (
    <form name="validateToken" onSubmit={handleSubmitToken}>
      <label htmlFor="token">
        <input
          id="token"
          name="token"
          type="text"
          className="inputTokenValido"
          autoComplete="off"
          onChange={handleChangeToken}
        />
      </label>
      {error && <Notification title={error} />}
      <button
        className="red-claro-btn FirstBtn"
        type="submit"
      >
        <span>{btnText}</span>
      </button>
      <button
        className="red-claro-btn secondBtn"
        type="button"
        onClick={tokenReenviar}
      >
        <span>{resend}</span>
      </button>
    </form>
  );
}

export default FormIsPostPagoComponent;
